<template>
  <div id="init-home-container" class="d-flex background_color">
    <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->

    <!-- <auth></auth> -->
    <v-spacer></v-spacer>
    <v-main style="padding: 0 !important">
      <titlecard :title_text="'WORK APPLICANT REGISTRATION UNIT'"></titlecard>
      <top_card :descr_text="descr_text"></top_card>
      <v-container class="background_color black--text" id="home-container">
        <template>
          <div id="big-card" class="d-flex justify-center align-center">
            <v-card
              id="home-content-area"
              class=""
              color="white"
              elevation="4"
              outlined
            >
              <div
                id="contains-expansions-layout"
                class="d-flex justify-center"
              >
                <v-expansion-panels id="all-panels" accordion>
                  <!-- BUSINESS OWNERS & PRIVILEGED LICENSEES -->
                  <!-- <wcrd_bus_own_priv_lic
                    @onExpansionPanelClick="onExpansionPanelClick"
                  ></wcrd_bus_own_priv_lic> -->

                  <!-- FINGERPRINTING -->
                  <!-- <wcrd_fngrprntng
                    @onExpansionPanelClick="onExpansionPanelClick"
                  ></wcrd_fngrprntng> -->

                  <!-- REGISTRATION FORMS -->
                  <!-- <wcrd_reg_frms
                    @onExpansionPanelClick="onExpansionPanelClick"
                  ></wcrd_reg_frms> -->

                  <!-- SEX OFFENDER - NEW OFFENDER for RPD REGISTRATION -->
                  <wcrd_sex_off
                    @onExpansionPanelClick="onExpansionPanelClick"
                  ></wcrd_sex_off>

                  <wcrd_sex_off_chkin
                    @onExpansionPanelClick="onExpansionPanelClick"
                  ></wcrd_sex_off_chkin>

                  <!-- EX FELON REGISTRATION  -->
                  <wcrd_ex_fel
                    @onExpansionPanelClick="onExpansionPanelClick"
                  ></wcrd_ex_fel>

                  <!-- CITY OF RENO/RPD EMPLOYEE -->
                  <wcrd_city_emp
                    @onExpansionPanelClick="onExpansionPanelClick"
                  ></wcrd_city_emp>

                  <!-- WORK CARDS REQUIRED - DANCERS/ADULT INTERACTIVE CABARET EMPLOYEES/ESCORT/MASSAGE PARLOR/TOW TRUCK DRIVERS/PAWN OR 2ND HAND EMPLOYEES/VEHICLE FOR HIRE -->
                  <wcrd_city_escorts_etc
                    @onExpansionPanelClick="onExpansionPanelClick"
                  ></wcrd_city_escorts_etc>

                  <!-- ISSUANCE OF WORK CARDS -->
                  <!-- <wcrd_iss_wrk_crds
                    @onExpansionPanelClick="onExpansionPanelClick"
                  ></wcrd_iss_wrk_crds> -->

                  <!-- ALCOHOL LICENSE(NON GAMING)/PAWN SHOP DEALER OR 2ND HAND OWNERS/MASSAGE PARLOR OWNERS -->
                  <wcrd_alchol_pawn
                    @onExpansionPanelClick="onExpansionPanelClick"
                  ></wcrd_alchol_pawn>

                  <!-- WORK APPLICANT UNIT PHONE NUMBER/HOURS OF OPERATION -->
                  <wcrd_phn_hrs
                    @onExpansionPanelClick="onExpansionPanelClick"
                  ></wcrd_phn_hrs>

                  <!-- WORK APPLICANT UNIT FEE SCHEDULE -->
                  <wcrd_fee_sch
                    @onExpansionPanelClick="onExpansionPanelClick"
                  ></wcrd_fee_sch>
                </v-expansion-panels>
              </div>
            </v-card>
          </div>
        </template>
      </v-container>
    </v-main>
    <v-spacer></v-spacer>
    <v-btn
      @click.prevent="fabup"
      class="fabup"
      elevation="2"
      fab
      color="yellow accent-2"
    >
      <v-icon color="black" dark x-large> $chevup </v-icon>
    </v-btn>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  .fabup {
    position: fixed;
    left: 85%;
    top: 90%;
    z-index: 500;
  }
  a {
    color: blue;
  }
  #all-panels {
    width: 90%;
  }
  .v-main {
    padding: 0 !important;
  }

  .theme--light.v-expansion-panels .v-expansion-panel {
    color: white;
  }

  .results .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap,
  .recent .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
    padding: 0 7px !important;
  }
  .bcs-expansion-content {
    color: black;
  }
  .alice {
    color: aliceblue;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .fabup {
    position: fixed;
    left: 95%;
    top: 90%;
  }
  .basic-interior-card {
    min-height: 200px;
  }
  #init-home-container {
    width: 100%;
  }
  #home-container {
    width: 100vw;

    height: auto;
    position: relative;
    top: 0px;
  }
  #home-content-area {
    width: 100%;
    max-width: 85%;
    height: auto;
    background-color: white;
  }
  #all-panels {
    width: 95%;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import top_card from "../components/top_card.vue";
const titlecard = () => import("./titlecard.vue");
const wcrd_bus_own_priv_lic = () => import("./wcrd_bus_own_priv_lic.vue");
const wcrd_fngrprntng = () => import("./wcrd_fngrprntng.vue");
const wcrd_reg_frms = () => import("./wcrd_reg_frms.vue");
const wcrd_iss_wrk_crds = () => import("./wcrd_iss_wrk_crds.vue");
const wcrd_phn_hrs = () => import("./wcrd_phn_hrs.vue");
const wcrd_fee_sch = () => import("./wcrd_fee_sch.vue");
const wcrd_sex_off = () => import("./wcrd_sex_off.vue");
const wcrd_sex_off_chkin = () => import("./wcrd_sex_off_chkin.vue");
const wcrd_ex_fel = () => import("./wcrd_ex_fel.vue");
const wcrd_city_emp = () => import("./wcrd_city_emp.vue");
const wcrd_alchol_pawn = () => import("./wcrd_alchol_pawn.vue");
const wcrd_city_escorts_etc = () => import("./wcrd_city_escorts_etc.vue");

export default {
  name: "wcrds_workcards",
  components: {
    top_card,
    wcrd_bus_own_priv_lic,
    wcrd_fngrprntng,
    wcrd_reg_frms,
    wcrd_iss_wrk_crds,
    wcrd_phn_hrs,
    wcrd_fee_sch,
    wcrd_alchol_pawn,
    titlecard,
    wcrd_sex_off,
    wcrd_sex_off_chkin,
    wcrd_ex_fel,
    wcrd_sex_off,
    wcrd_city_emp,
    wcrd_city_escorts_etc,
  },
  mixins: [bus_common],
  data() {
    // Status, Fname, Lnprivateame, DOB, DIVISION
    return {
      descr_text: `The Work Applicant Registration Unit is responsible for
                      the registration of convicted persons and the processing
                      and fingerprinting of employees for the issuance of work
                      cards as required by Reno Municipal Code and Nevada
                      Revised Statute, i.e. taxi, limousine, and tow truck
                      drivers, massage technicians, exotic dancers, and
                      solicitors. This Unit is also charged with the
                      responsibility of fingerprinting and issuing City employee
                      identification cards.`,
    };
  },
  watch: {
    // "$store.state.user": function () {
    //   //keep this
    //   let self = this;
    //   this.init();
    // },
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    fabup() {
      const bdy = document.getElementsByClassName("bodyback")[0];
      bdy.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    onExpansionPanelClick(event) {
      var targetID = event.currentTarget.id;
      var self = this;
      if (
        event.currentTarget.classList.contains(
          "v-expansion-panel-header--active"
        )
      ) {
        console.log("Panel is closing/now closed.");
      } else {
        console.log("Panel is opening/now open.");
        setTimeout(
          function () {
            //   window.scroll(0, 3500);
            console.log(targetID);
            const daWindow = document.getElementById("vapp");
            const element = document.getElementById(targetID);
            element.scrollIntoView({ behavior: "smooth" });
          },
          250,
          targetID
        );
      }
    },
    init(self) {
      this.show_loader(false);
    },
  },
  mounted() {
    document.title = "WORK APPLICANT REGISTRATION UNIT";
    var self = this;
    this.$nextTick(() => {
      this.init(self);
    });
  },
};
</script>
